// extracted by mini-css-extract-plugin
module.exports = {"loupe":"_9400a595a7--loupe--RAb0j"};